import pubConfs from './btnPubConfs'
import appConfs from '../../pubConfig/btnConfs'
const emptyObject = {}
const caches = {}

const genConf = title => {
	const ret = {}
	ret.appConf = appConfs[title] || emptyObject
	ret.pubConf = (() => {
		for (const v of Object.values(pubConfs)) {
			for (const n of v.starts || [])
				if (title.startsWith(n))
					return v
			for (const n of v.ends || [])
				if (title.endsWith(n))
					return v
			for (const n of v.includes || [])
				if (title.includes(n))
					return v
		}
		return emptyObject
	})()

	// console.log(title, ret.appConf, ret.pubConf)
	return ret
}

const getConf = ({ btnName, _button, _tool, text }) => {
	let title = btnName || _button || _tool || text
	title = typeof title === 'string' ? title.toUpperCase() : ''

	return caches[title] = caches[title] || genConf(title)
}

const reconfigButton = ({ icon, ui, ...config }) => {
	const { appConf, pubConf } = getConf(config)

	// 暂时保留button上所定义icon、ui
	config.icon = icon !== undefined ? icon : Tyan.isPhone ? null : appConf.icon !== undefined ? appConf.icon : pubConf.icon
	config.ui = ui !== undefined
		? ui
		: (o => Tyan.isPhone ? (o || '').split(' ').filter(o => o === 'decline').join(' ') : o)(appConf.ui !== undefined ? appConf.ui : pubConf.ui)
	// config.icon = typeof icon === 'function' ? icon : appConf.icon !== undefined ? appConf.icon : pubConf.icon
	// config.ui = typeof ui === 'function' ? ui : appConf.ui !== undefined ? appConf.ui : pubConf.ui
	config = {
		...config,
		...(appConf.props !== undefined ? (appConf.props || {}) : (pubConf.props || {}))
	}

	return config
}


export const isHelpBtn = (config) => {
	const { pubConf } = getConf(config)
	return !!(pubConf === pubConfs.HELP)
}

export default reconfigButton
